//  Copyright (c) 2018 First Foundry Inc. All rights reserved.

export { default as persistStateMiddleware } from './persistState'
export * from './persistState'
